// extracted by mini-css-extract-plugin
module.exports = {"centeredContainer":"centered-container_centeredContainer__2XKv_"};